import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100'
          : 'bg-transparent'
      }`}
      style={{ height: '80px' }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/b82cd702-b168-461f-af40-a8ad59f7f12d.png"
            alt="CICHORZ Logo"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`text-xl font-bold tracking-widest transition-colors duration-300 ${
              scrolled || !isHome ? 'text-[#0A1628]' : 'text-white'
            }`}
          >
            CICHORZ
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-widest uppercase transition-all duration-200 whitespace-nowrap relative group ${
                scrolled || !isHome ? 'text-[#374151]' : 'text-white/80'
              } ${location.pathname === link.path ? 'opacity-100' : 'opacity-80 hover:opacity-100'}`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-px transition-all duration-200 ${
                  location.pathname === link.path
                    ? 'w-full bg-[#0A1628]'
                    : 'w-0 group-hover:w-full bg-[#0A1628]'
                }`}
              />
            </Link>
          ))}
          <Link
            to="/contact"
            className="ml-4 px-5 py-2.5 bg-[#0A1628] text-white text-sm font-semibold tracking-widest uppercase rounded-full hover:bg-[#1a2f4f] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Devis gratuit
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden flex flex-col gap-1.5 cursor-pointer p-2 ${
            scrolled || !isHome ? 'text-[#0A1628]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white/98 backdrop-blur-md shadow-lg border-t border-gray-100">
          <div className="flex flex-col px-6 py-6 gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium tracking-widest uppercase py-2 border-b border-gray-100 cursor-pointer ${
                  location.pathname === link.path ? 'text-[#0A1628] font-bold' : 'text-[#374151]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-2 px-5 py-3 bg-[#0A1628] text-white text-sm font-semibold tracking-widest uppercase rounded-full text-center whitespace-nowrap cursor-pointer"
            >
              Devis gratuit
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
